import React from 'react';

import { CardSkeleton } from '../../Skeleton';
import useBarData from './useBarData';
import BarView from './BarView';

const BarContent = ({
  chartDefinition,
  chartRef,
  isHorizontal,
  isCombo,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  isHorizontal?: boolean;
  isCombo?: boolean;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData } = useBarData({
    chartDefinition,
    chartRef,
    isHorizontal,
    isCombo,
  });

  if (!options) {
    return <CardSkeleton />;
  }

  return (
    <BarView
      chartRef={chartRef}
      options={options}
      isNoData={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default BarContent;
